{
  "name": "ecole-du-papillon-invisible",
  "version": "1.5.2",
  "description": "École du Papillon Invisible",
  "author": "Thomas Egain",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/tegain/ecole-du-papillon-invisible.git"
  },
  "license": "MIT",
  "private": true,
  "engines": {
    "node": "^22.12.0"
  },
  "scripts": {
    "nx": "nx",
    "postinstall": "husky install",
    "chore:format": "nx format:write --libs-and-apps",
    "chore:lint": "nx run-many -t lint",
    "back-office:start": "nx serve back-office",
    "back-office:build": "nx build back-office",
    "back-office:build:staging": "nx build back-office -c staging",
    "back-office:test": "nx test back-office",
    "back-office:test:ci": "nx test back-office",
    "back-office:lint": "nx lint back-office --fix",
    "backend:build": "nx build backend",
    "backend:start": "nx build backend && nx serve backend",
    "backend:deploy:staging": "firebase deploy --config=firebase.json --only functions  --project ecolepapilloninvisible-dev",
    "backend:deploy:production": "firebase deploy --config=firebase.json --only functions --project ecolepapilloninvisible",
    "backend:lint": "nx lint backend --fix",
    "backend-api:start": "nx serve backend-api",
    "backend-api:build": "nx build backend-api",
    "backend-api:lint": "nx lint backend-api",
    "user-guide:start": "nx serve user-guide",
    "user-guide:build": "nx build user-guide",
    "user-guide:deploy:staging": "firebase deploy --only hosting:user-guide --project ecolepapilloninvisible-dev",
    "website:start": "nx serve website",
    "website:build": "nx build website",
    "website:build:ssr": "nx build-ssr website"
  },
  "dependencies": {
    "@angular/animations": "~20.2.0",
    "@angular/cdk": "~20.2.0",
    "@angular/common": "~20.2.0",
    "@angular/compiler": "~20.2.0",
    "@angular/core": "~20.2.0",
    "@angular/fire": "~20.0.1",
    "@angular/forms": "~20.2.0",
    "@angular/platform-browser": "~20.2.0",
    "@angular/platform-browser-dynamic": "~20.2.0",
    "@angular/router": "~20.2.0",
    "@date-fns/tz": "^1.0.2",
    "@nestjs/common": "^11.0.1",
    "@nestjs/config": "^4.0.2",
    "@nestjs/core": "^11.0.1",
    "@nestjs/jwt": "^11.0.0",
    "@nestjs/platform-express": "^11.0.1",
    "@nestjs/serve-static": "^5.0.3",
    "@nestjs/terminus": "^11.0.0",
    "@nestjs/throttler": "^6.4.0",
    "@nuxtjs/i18n": "8.3.1",
    "@primeng/themes": "~19.0.6",
    "@primeuix/themes": "^1.2.3",
    "@rx-angular/cdk": "~20.0.0",
    "@rx-angular/template": "~20.0.0",
    "@sentry/angular": "~10.10.0",
    "@sentry/cli": "~2.53.0",
    "@sentry/nestjs": "~10.3.0",
    "@sentry/profiling-node": "~10.3.0",
    "@supercharge/promise-pool": "~3.2.0",
    "@vee-validate/nuxt": "4.13.1",
    "@vee-validate/yup": "4.13.1",
    "bcrypt": "~6.0.0",
    "body-parser": "~1.20.3",
    "class-transformer": "^0.5.1",
    "class-validator": "^0.14.2",
    "cookie-parser": "^1.4.7",
    "cors": "^2.8.5",
    "date-fns": "^4.1.0",
    "dotenv": "^17.2.2",
    "express": "^5.1.0",
    "firebase": "^12.2.1",
    "firebase-admin": "~13.5.0",
    "firebase-functions": "~6.4.0",
    "helmet": "~8.1.0",
    "inversify": "^6.0.2",
    "kysely": "^0.28.5",
    "liquidjs": "~10.21.0",
    "morgan": "^1.10.0",
    "mysql2": "^3.14.5",
    "nanoid": "~5.1.5",
    "nest-winston": "^1.10.2",
    "nestjs-cls": "^6.0.1",
    "primeflex": "~3.3.1",
    "primeicons": "~7.0.0",
    "primeng": "~20.1.1",
    "primevue": "3.53.0",
    "puppeteer": "~24.19.0",
    "quill": "~1.3.7",
    "ramda": "~0.30.0",
    "reflect-metadata": "^0.2.2",
    "rxjs": "~7.8.0",
    "sharp": "~0.33.4",
    "tslib": "^2.3.0",
    "vee-validate": "~4.13.1",
    "vue-recaptcha-v3": "^2.0.1",
    "winston": "^3.17.0",
    "winston-daily-rotate-file": "^5.0.0",
    "zod": "~4.1.7",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@analogjs/platform": "^1.13.0",
    "@analogjs/vite-plugin-angular": "^1.13.0",
    "@analogjs/vitest-angular": "^1.13.0",
    "@angular-devkit/build-angular": "~20.2.0",
    "@angular-devkit/core": "~20.2.0",
    "@angular-devkit/schematics": "~20.2.0",
    "@angular-eslint/eslint-plugin": "~20.2.0",
    "@angular-eslint/eslint-plugin-template": "~20.2.0",
    "@angular-eslint/template-parser": "~20.2.0",
    "@angular/cli": "~20.2.0",
    "@angular/compiler-cli": "~20.2.0",
    "@angular/language-service": "~20.2.0",
    "@commitlint/cli": "~19.8.0",
    "@commitlint/config-angular": "~19.8.0",
    "@eslint/eslintrc": "^3.2.0",
    "@eslint/js": "^9.18.0",
    "@nestjs/cli": "^11.0.0",
    "@nestjs/schematics": "^11.0.0",
    "@nestjs/testing": "^11.0.1",
    "@nuxtjs/seo": "2.0.0-rc.11",
    "@nuxtjs/sitemap": "5.2.2",
    "@nx-toolkits/firebase": "~0.7.1",
    "@nx/angular": "~21.5.0",
    "@nx/devkit": "~21.5.0",
    "@nx/esbuild": "~21.5.0",
    "@nx/eslint": "~21.5.0",
    "@nx/eslint-plugin": "~21.5.0",
    "@nx/jest": "~21.5.0",
    "@nx/js": "~21.5.1",
    "@nx/nest": "~21.5.1",
    "@nx/node": "~21.5.1",
    "@nx/playwright": "~21.5.0",
    "@nx/react": "~21.5.0",
    "@nx/vite": "~21.5.0",
    "@nx/web": "~21.5.1",
    "@nx/webpack": "~21.5.1",
    "@nx/workspace": "~21.5.0",
    "@playwright/test": "~1.41.0",
    "@schematics/angular": "~20.2.0",
    "@swc-node/register": "~1.10.9",
    "@swc/cli": "^0.6.0",
    "@swc/core": "~1.10.9",
    "@swc/helpers": "~0.5.11",
    "@trivago/prettier-plugin-sort-imports": "~5.2.2",
    "@types/bcrypt": "~6.0.0",
    "@types/cookie-parser": "^1.4.9",
    "@types/express": "^5.0.0",
    "@types/jest": "~29.5.10",
    "@types/morgan": "^1.9.10",
    "@types/node": "^22.18.0",
    "@types/quill": "^1.3.10",
    "@types/ramda": "~0.30.0",
    "@types/supertest": "^6.0.2",
    "@typescript-eslint/eslint-plugin": "~8.43.0",
    "@typescript-eslint/parser": "~8.43.0",
    "@vitest/coverage-v8": "~3.2.4",
    "@vitest/ui": "~3.2.4",
    "axios": "~1.11.0",
    "cross-fetch": "~4.1.0",
    "esbuild": "~0.25.9",
    "eslint": "~9.35.0",
    "eslint-config-prettier": "~10.1.8",
    "eslint-plugin-import": "~2.32.0",
    "eslint-plugin-playwright": "~2.2.2",
    "eslint-plugin-unused-imports": "~4.2.0",
    "firebase-tools": "~14.15.2",
    "globals": "^16.0.0",
    "husky": "~8.0.3",
    "jest": "~29.7.0",
    "jest-environment-jsdom": "~29.7.0",
    "jest-environment-node": "~29.7.0",
    "jest-marbles": "~3.0.6",
    "jest-util": "^30.0.2",
    "jsdom": "^26.0.0",
    "jsonc-eslint-parser": "~2.4.0",
    "lint-staged": "~15.2.0",
    "node-mailjet": "~6.0.5",
    "nuxt": "3.12.4",
    "nuxt-og-image": "3.0.0-rc.65",
    "nuxt-primevue": "0.3.1",
    "nx": "~21.5.0",
    "prettier": "~3.6.2",
    "sass": "^1.89.2",
    "source-map-support": "^0.5.21",
    "supertest": "^7.0.0",
    "ts-jest": "~29.2.5",
    "ts-loader": "^9.5.2",
    "ts-node": "10.9.2",
    "tsconfig-paths": "^4.2.0",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.20.0",
    "vite": "~7.1.5",
    "vite-tsconfig-paths": "~5.1.4",
    "vitest": "~3.2.4",
    "vue": "~3.4.30",
    "vue-router": "~4.4.0",
    "webpack-cli": "^5.1.4"
  },
  "overrides": {
    "nitropack": {
      ".": "2.10.4",
      "@rollup/plugin-replace": "6.0.2"
    }
  },
  "lint-staged": {
    "*.{js,json,css,scss,less,md,ts,html,component.html}": [
      "npm run chore:format",
      "git add"
    ]
  }
}
